export default __webpack_public_path__ + "static/media/logo-musaned-ar.cd2031cf.svg";